import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { goldSilverPaymentFormStyles } from './styles';
import Message from '../../../../../../common/Message';
import {
  messageGoldSilverAlert,
  messageNotGoldSilverAlert,
} from '../../../../../../../constants/Messages';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';

import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';

const GoldSilverPaymentForm = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile, onData } = props;
  const [value, setValue] = useState('');
  const [helperText, setHelperText] = useState('0/250');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { category } = useSelector((state) => state.loyaltyReducer);
  const { ticketNoProductStatus: ticketStatus, ticket } = useSelector(
    (state) => state.ticketReducer,
  );
  const dispatch = useDispatch();
  const classes = goldSilverPaymentFormStyles({ mobile });

  const validateGoldSilver = () => category === 'gold' || category === 'silver';

  const handleComment = (event) => {
    const { value } = event.target;
    setHelperText(`${value.length}/250`);
    setValue(value);
  };

  const blurComment = (event) => {
    const { value } = event.target;
    if (value.length > 20) {
      setSuccess(true);
      setError(false);
      setDisabled(false);
    } else {
      setSuccess(false);
      setError(true);
      setDisabled(true);
    }
  };

  const onClickSent = () => {
    const body = bodyTicketProductGenerator({
      profile,
      type,
      motiveId,
      product,
      comment: value,
    });
    dispatch(createTicketNoProduct(body));
  };

  useEffect(() => {
    if (ticketStatus === 'succeded') {
      onData({ motiveId, message: ticket.ticketId, noProduct: true });
    }
  }, [ticketStatus]);

  return (
    <React.Fragment>
      <Box className={classes.container}>
        <Message
          severity="info"
          message={
            validateGoldSilver()
              ? messageGoldSilverAlert
              : messageNotGoldSilverAlert
          }
          fullRounded
        />
        {validateGoldSilver() && (
          <React.Fragment>
            <Box marginTop="6px">
              <AppInput
                required
                multiline
                label="Escribir comentario"
                errorMessage="Comentario requerido"
                onBlur={blurComment}
                onChange={handleComment}
                helperText={helperText}
                onClick={() => {}}
                value={value}
                error={error}
                success={success}
              />
            </Box>
            <AuthorizeCheckbox
              idComplement="FormGoldSilverPayment"
              disabled={disabled}
              onCheck={() => setChecked(!checked)}
            />
            <div className={classes.divButtonLoading}>
              <LoadingButton
                variant="contained"
                loading={ticketStatus === 'loading'}
                color="primary"
                name="ButtonSentSilverGoldForm"
                text="Enviar"
                disabled={!checked || disabled}
                onClick={onClickSent}
                className={classes.buttonSent}
                data-cy="ButtonSentSilverGoldForm"
              />
            </div>
          </React.Fragment>
        )}
      </Box>
    </React.Fragment>
  );
};

GoldSilverPaymentForm.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default GoldSilverPaymentForm;
